import React from 'react';
import styled from 'styled-components';

import { useEditEventContext } from '../../contexts/EditEventContext';
import EditableColorBox from './EditableColorBox';

const MultiColorPicker = () => {
  const eventContext = useEditEventContext();

  const colors = eventContext.event?.colors;

  const onColorChange = (color: string, key: 'primary' | 'secondary' | 'highlightText' | 'text') => {
    if (eventContext.event?.colors) {
      eventContext.setColors({ ...eventContext.event.colors, [key]: color });
    }
  };

  if (!colors) {
    return null;
  }

  return <ThemeBox>
    <ColorBoxes>
      <EditableColorBox color={colors.primary} id="primary-color" onChange={(color) => onColorChange(color, 'primary')}
                        title="Background"/>
      <EditableColorBox color={colors.secondary} id="secondary-color"
                        onChange={(color) => onColorChange(color, 'secondary')} title="Background Accent"/>
      <EditableColorBox color={colors.text} id="text-color" onChange={(color) => onColorChange(color, 'text')}
                        title="Text"/>
      <EditableColorBox color={colors.highlightText} id="highlight-text-color"
                        onChange={(color) => onColorChange(color, 'highlightText')} title="Highlight"/>
    </ColorBoxes>
  </ThemeBox>;
};

const ThemeBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ColorBoxes = styled.div`
  display: flex;
  gap: 10px;
`;

export default MultiColorPicker;
